import { render, staticRenderFns } from "./appmartDash.vue?vue&type=template&id=0454867d&scoped=true&"
import script from "./appmartDash.vue?vue&type=script&lang=js&"
export * from "./appmartDash.vue?vue&type=script&lang=js&"
import style0 from "./appmartDash.vue?vue&type=style&index=0&id=0454867d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0454867d",
  null
  
)

export default component.exports